/* implTakeRate.js -- W-007: THE TAKE RATE, as typed in Revenue Build's "Take Rate (%)" box.
 *
 * The take rate is the share of new clients who buy implementation (netImpl = new clients x fee x take_rate), so it runs 0% to 100%
 * (Brian, 09-25). 0 is an ANSWER ("none"); a BLANK is refused -- the operator types 0. The server refuses the same values
 * (server.js validateImplTakeRate); this is the courtesy, that is the guarantee.
 *
 * WHY A TEXT DRAFT: the box used to be controlled by the stored NUMBER, rounded with r2 (a money rounder) -- so "12." snapped back to
 * "12", a fractional percent could not be typed at all, and a typed 12.5% was stored as 0.13 (+$2,250 over 9 months on a $50,000/month
 * forge). The page now keeps the text as typed and parses it here, to the column's own precision: numeric(6,4) holds 4 decimals of the
 * fraction, i.e. 2 decimals of a percent (12.345% -> 0.1235, as the column itself would round it). */

export const TAKE_RATE_RANGE_MESSAGE = 'Take rate must be between 0% and 100%.';
export const TAKE_RATE_REQUIRED_MESSAGE = 'Required \u2014 enter 0 for none';

// the typed text -> { rate: a fraction in [0, 1], error: null } | { rate: null, error: <message> }
export function parseTakeRateText(text) {
  const t = String(text == null ? '' : text).trim();
  if (t === '') return { rate: null, error: TAKE_RATE_REQUIRED_MESSAGE };
  if (!/^(\d+(\.\d*)?|\.\d+)$/.test(t)) return { rate: null, error: TAKE_RATE_RANGE_MESSAGE };
  const pct = Number(t);
  if (!Number.isFinite(pct) || pct < 0 || pct > 100) return { rate: null, error: TAKE_RATE_RANGE_MESSAGE };
  return { rate: Math.round(pct * 100) / 10000, error: null };
}

// a stored fraction -> the box's text (1 -> "100", 0.125 -> "12.5", 0 -> "0"); '' when there is no number
export function takeRateText(rate) {
  const n = Number(rate);
  if (rate === null || rate === undefined || rate === '' || !Number.isFinite(n)) return '';
  return String(Math.round(n * 1000000) / 10000);
}
